import { withTimeout } from '@/lib/saveTimeout'
import { ValidationError } from '@/lib/errorReporter'

// U17 D3: the database lets only some roles change sticker ranges
// (packing_token_allocations RLS). A DELETE that RLS filters out returns NO
// error and NO rows, so the screen used to say "Token range removed" when
// nothing was removed. The delete now asks for the rows it removed.
export const TOKEN_RANGE_ROLE_REFUSAL = 'Your role cannot change sticker ranges. Ask a manager.'

type DeleteClient = {
  from: (t: string) => {
    delete: () => {
      eq: (c: string, v: string) => {
        select: (cols: string) => PromiseLike<{ data: unknown[] | null; error: { message?: string; code?: string } | null }>
      }
    }
  }
}

export function isRlsRefusal(e: { message?: string; code?: string } | null | undefined): boolean {
  return !!e && (e.code === '42501' || /row-level security|permission denied/i.test(e.message ?? ''))
}

export async function removeTokenAllocation(client: DeleteClient, id: string): Promise<void> {
  const { data, error } = await withTimeout(
    client.from('packing_token_allocations').delete().eq('allocation_id', id).select('allocation_id'),
    'Runs: packing_token_allocations delete',
  )
  if (error) {
    if (isRlsRefusal(error)) throw new ValidationError(TOKEN_RANGE_ROLE_REFUSAL)
    throw error
  }
  if (!data || data.length === 0) throw new ValidationError(TOKEN_RANGE_ROLE_REFUSAL)
}
